module.exports = __webpack_public_path__ + "img/Zones-Icon.svg";